import { render } from "./LottoResultView.vue?vue&type=template&id=fad8cd9a&ts=true"
import script from "./LottoResultView.vue?vue&type=script&lang=ts"
export * from "./LottoResultView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__